import ConfirmDialog from './confirm-dialog';

export type DeleteDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  description?: string;
  itemName?: string;
  isLoading?: boolean;
  confirmText?: string;
  cancelText?: string;
  className?: string;
};

function DeleteDialog({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Deletion',
  description,
  itemName,
  isLoading = false,
  confirmText = 'Delete',
  cancelText = 'Cancel',
  className,
}: Readonly<DeleteDialogProps>) {
  const defaultDescription = itemName
    ? `Are you sure you want to delete ${itemName}? This action cannot be undone.`
    : 'Are you sure you want to delete this item? This action cannot be undone.';

  return (
    <ConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      description={description ?? defaultDescription}
      isLoading={isLoading}
      confirmText={confirmText}
      cancelText={cancelText}
      confirmVariant="error"
      className={className}
    />
  );
}

export { DeleteDialog };
export default DeleteDialog;
